// src/components/Common/ProductSizeManager.js
import React from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
} from '@mui/material';
import { Add, Delete as DeleteIcon } from '@mui/icons-material';
import { useNumberValidation } from '../../hooks/useNumberValidation';

const ProductSizeManager = ({ sizes, onSizeUpdate, rtlTextFieldProps }) => {
  const { validateNumberInput } = useNumberValidation();

  const handleSizeChange = (sizeIndex, field, value) => {
    const updatedSizes = [...sizes];
    
    // Apply number validation for stock field
    if (field === 'stock') {
      value = validateNumberInput(value, false); // No decimals for stock
    }
    
    updatedSizes[sizeIndex][field] = value;
    onSizeUpdate(updatedSizes);
  };

  const handleAddSize = () => {
    const newSize = { size: '', stock: '' };
    onSizeUpdate([...sizes, newSize]);
  };

  const handleRemoveSize = (sizeIndex) => {
    const updatedSizes = sizes.filter((_, i) => i !== sizeIndex);
    onSizeUpdate(updatedSizes);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', textAlign: 'right', direction: 'rtl', mb: 1 }}>
        المقاسات والكميات:
      </Typography>
      {sizes.map((size, sizeIndex) => (
        <Box key={sizeIndex} sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1, 
          mb: 1,
          alignItems: { xs: 'stretch', sm: 'center' }
        }}>
          <TextField
            label="المقاس"
            value={size.size}
            onChange={e => handleSizeChange(sizeIndex, 'size', e.target.value)}
            {...rtlTextFieldProps}
            sx={{ 
              ...rtlTextFieldProps.sx, 
              flex: 1,
              minWidth: { xs: '100%', sm: 120 }
            }}
          />
          <TextField
            label="الكمية"
            type="number"
            value={size.stock}
            onChange={e => handleSizeChange(sizeIndex, 'stock', e.target.value)}
            inputProps={{
              ...rtlTextFieldProps.inputProps,
              min: "0",
              step: "1"
            }}
            {...rtlTextFieldProps}
            sx={{ 
              ...rtlTextFieldProps.sx, 
              width: { xs: '100%', sm: 100 }
            }}
          />
          <IconButton 
            onClick={() => handleRemoveSize(sizeIndex)}
            sx={{ 
              alignSelf: { xs: 'center', sm: 'center' },
              mt: { xs: 1, sm: 0 }
            }}
          >
            <DeleteIcon color="error" />
          </IconButton>
        </Box>
      ))}
      <Button variant="outlined" endIcon={<Add />} onClick={handleAddSize} sx={{ fontWeight: 'bold' }}>
        إضافة مقاس
      </Button>
    </Box>
  );
};

export default ProductSizeManager;
